import styled from 'styled-components'

export const ItemBg = styled.div`
  background: #ffffff;
  padding: 20px;
  width: 100%;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  border: 1px solid #f0f0f0;
  transition: all 0.3s ease;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 100%;

  &:hover {
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.12);
    transform: translateY(-2px);
    border-color: #e6e6e6;
  }
`

export const ItemSubject = styled.h1`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #262626;
  margin: 0;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;

  @media (max-width: 1440px) {
    font-size: 15px;
    line-height: 22px;
  }
`

export const ItemContent = styled.span`
  font-size: 13px;
  line-height: 20px;
  color: #595959;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;

  figure img {
    width: 100%;
  }
`

export const ItemAttachmentLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: #262626;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
  display: block;
`
